/**
 * drawingChecksApi — CR-2026-DC-FINAL-CHECK (D-032 §5.2 + §15.2).
 */

import ApiCall from './apicall';

export const CHECK_RESULTS = ['IN_PROGRESS', 'ACCEPTED', 'REJECTED', 'AMENDED'];
export const RESULT_LABELS = { IN_PROGRESS: 'In Progress', ACCEPTED: 'Accepted', REJECTED: 'Rejected', AMENDED: 'Amended' };
export const resultLabel = (r) => RESULT_LABELS[r] || r;
export const CHECK_AREAS = [
  'geometry_checked', 'connections_checked', 'material_checked',
  'welding_checked', 'coating_checked', 'erection_checked', 'completeness_checked',
];
export const CHECK_AREA_LABELS = {
  geometry_checked: 'Geometry & dimensions',
  connections_checked: 'Connections',
  material_checked: 'Material',
  welding_checked: 'Welding',
  coating_checked: 'Coating / paint',
  erection_checked: 'Erection / field',
  completeness_checked: 'Completeness',
};
export const EXCEPTION_AREAS = [
  'GEOMETRY', 'CONNECTIONS', 'MATERIAL', 'WELDING',
  'COATING', 'ERECTION', 'COMPLETENESS', 'OTHER',
];
export const EXCEPTION_SEVERITY = ['MINOR', 'MAJOR', 'CRITICAL'];

const ALLOWED_TRANSITIONS = {
  IN_PROGRESS: ['ACCEPTED', 'REJECTED', 'AMENDED'],
  ACCEPTED: ['AMENDED'],
  REJECTED: ['IN_PROGRESS'],
  AMENDED: ['ACCEPTED', 'REJECTED'],
};
export const allowedCheckTransitions = (result) => ALLOWED_TRANSITIONS[result] || [];

export async function listChecks(filters = {}) {
  const params = new URLSearchParams();
  if (filters.document_id) params.set('document_id', filters.document_id);
  if (filters.job_id) params.set('job_id', filters.job_id);
  if (filters.checker_user_id) params.set('checker_user_id', filters.checker_user_id);
  if (filters.result) params.set('result', filters.result);
  const qs = params.toString();
  const { data } = await ApiCall.get(`/drawing-checks${qs ? `?${qs}` : ''}`);
  return data;
}

export async function getCheck(id) {
  const { data } = await ApiCall.get(`/drawing-checks/${id}`);
  return data;
}

export async function createCheck(payload) {
  const { data } = await ApiCall.post('/drawing-checks', payload);
  return data;
}

export async function addExceptions(id, exceptions) {
  const { data } = await ApiCall.post(`/drawing-checks/${id}/exceptions`, { exceptions });
  return data;
}

// CR-2026-BE-DC-DECISION-INTEGRITY: the checker's area attestations travel with the accept.
export const completeCheck = async (id, areas) => (await ApiCall.post(`/drawing-checks/${id}/complete`, { areas })).data;
export const rejectCheck = async (id, rejection_reason) => (await ApiCall.post(`/drawing-checks/${id}/reject`, { rejection_reason })).data;
export const amendCheck = async (id, amend_reason) => (await ApiCall.post(`/drawing-checks/${id}/amend`, { amend_reason })).data;

export async function getReleaseEligibility(documentId) {
  const { data } = await ApiCall.get(`/documents/${documentId}/release-eligible`);
  return data;
}
